module.exports = __webpack_public_path__ + "img/rich-unchecked-zh.160b4390.png";